/** The backend's ReportEventType, and how the dashboard names each one. */
export type EventType =
  | "REGISTRATION"
  | "APP_OPEN"
  | "INVITE_SHARED"
  | "REFERRAL"
  | "RECOMMENDATION"
  | "LEVEL_CHANGE"
  | "TEAM_JOINED"
  | "TEAM_MESSAGE";

export const EVENT_LABELS: Record<EventType, { singular: string; plural: string }> = {
  REGISTRATION: { singular: "Registered", plural: "Registrations" },
  APP_OPEN: { singular: "Opened the app", plural: "App opens" },
  INVITE_SHARED: { singular: "Shared invite link", plural: "Invite links shared" },
  REFERRAL: { singular: "Referred someone", plural: "Referrals" },
  RECOMMENDATION: { singular: "Recommended a place", plural: "Recommendations" },
  LEVEL_CHANGE: { singular: "Level changed", plural: "Level changes" },
  TEAM_JOINED: { singular: "Joined a community", plural: "Communities joined" },
  TEAM_MESSAGE: { singular: "Posted in a community", plural: "Community messages" },
};

export const EVENT_TYPES = Object.keys(EVENT_LABELS) as EventType[];
